/* Hand-drawn delivery zones, WGS84 (EPSG:4326) lng/lat. Drawn by CGF via
 * geojson.io. Each feature's `properties` drive the map:
 *   - `day`   : the label shown on the zone (e.g. "Thursday / Friday")
 *   - `color` : the zone fill/outline colour (hex)
 *   - `label` : internal name (fallback label if `day` is blank)
 * To update: redraw, export GeoJSON, replace the geometry below, and set the
 * day/colour. Add more Feature polygons for additional zones. Rendered by
 * sections/delivery-map.liquid. */
window.CGF_DELIVERY_RURAL_AREA = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": { "label": "St. Thomas / Port Stanley", "day": "Thursday", "color": "#4a7c4f" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-81.6546349, 42.5310216],
            [-81.6949475, 42.5704824],
            [-81.5071905, 42.6716647],
            [-81.3503632, 42.7749335],
            [-81.2955878, 42.6545502],
            [-81.6089309, 42.5002488],
            [-81.6546349, 42.5310216]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": { "label": "London & east", "day": "Thursday / Friday", "color": "#d98b3a" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-81.4148028, 43.0337503],
            [-81.1802701, 43.0911894],
            [-80.9596111, 43.0124987],
            [-80.9199718, 42.7544803],
            [-80.9754669, 42.6447509],
            [-81.2952242, 42.6462088],
            [-81.385734, 42.8044254],
            [-81.5548617, 42.9046786],
            [-81.4148028, 43.0337503]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": { "label": "Kitchener / Waterloo / Cambridge", "day": "Saturday", "color": "#467c99" },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-80.5907115, 43.5203532],
            [-80.4573097, 43.5301044],
            [-80.2675215, 43.4563513],
            [-80.257798, 43.333346],
            [-80.3151808, 43.3085744],
            [-80.4197595, 43.3369461],
            [-80.5657397, 43.3975073],
            [-80.6405408, 43.4583715],
            [-80.5907115, 43.5203532]
          ]
        ]
      }
    }
  ]
};
